import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log(error);

        // Handle error
        let errorMessage = '';
        if (error?.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `Error: ${error?.error?.message}`;
        } else {
          // Server-side error
          errorMessage = `Error Code: ${error?.status}\nMessage: ${error?.message}`;
        }
        console.error(errorMessage || 'An unknown error occurred');

        return throwError(error);
      })
    );
  }
}
